// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueWaypoint from 'vue-waypoint'
import VueResource from 'vue-resource'
// import { ApolloClient } from 'apollo-client'
// import { HttpLink } from 'apollo-link-http'
// import { InMemoryCache } from 'apollo-cache-inmemory'
// import VueApollo from 'vue-apollo'

Vue.config.productionTip = false

Vue.use(VueWaypoint)
Vue.use(VueResource)
// Vue.use(VueApollo)

// const shopifyAccessToken = 'cd6c295cb0e4c351d45757ab4f18ec80'
// const shopifyGraphQL = 'https://shop.hatopress.net/api/graphql'

// const authMiddleware = new ApolloLink((operation, forward) => {
//   // add the authorization to the headers
//   operation.setContext({
//     headers: {
//       'X-Shopify-Storefront-Access-Token': shopifyAccessToken,
//     }
//   });
//   return forward(operation);
// })
// // HTTP connexion to the API
// const httpLink = new HttpLink({
//   // You should use an absolute URL here
//   uri: shopifyGraphQL
// })
//
// // Cache implementation
// const cache = new InMemoryCache()
//
// // Create the apollo client
// const apolloClient = new ApolloClient({
//   link: httpLink,
//   cache
// })
//
// const apolloProvider = new VueApollo({
//   defaultClient: apolloClient
// })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  // apolloProvider,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js